// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var backIsSymbol = {
    reflectSymbol: function () {
        return "back";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(backIsSymbol);
var currentIsSymbol = {
    reflectSymbol: function () {
        return "current";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(currentIsSymbol);
var forwardIsSymbol = {
    reflectSymbol: function () {
        return "forward";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(forwardIsSymbol);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(forwardIsSymbol);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_List_Types.monoidList);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var $$null = /* #__PURE__ */ Data_Foldable["null"](Data_List_Types.foldableList);
var History = function (x) {
    return x;
};
var showHistory = function (dictShow) {
    var showList = Data_List_Types.showList(dictShow);
    return showRecord(showRecordFieldsCons(showRecordFieldsCons1(showRecordFieldsConsNil(showList))(Data_Maybe.showMaybe(dictShow)))(showList));
};
var eqHistory = function (dictEq) {
    var eqList = Data_List_Types.eqList(dictEq);
    return eqRec(Data_Eq.eqRowCons(Data_Eq.eqRowCons(eqRowCons(eqList))()(currentIsSymbol)(Data_Maybe.eqMaybe(dictEq)))()(backIsSymbol)(eqList));
};
var withCurrent = function (a) {
    return {
        current: new Data_Maybe.Just(a),
        back: mempty,
        forward: mempty
    };
};
var undo = function (v) {
    return bind(v.current)(function (cur) {
        if (v.back instanceof Data_List_Types.Nil) {
            return Data_Maybe.Nothing.value;
        };
        if (v.back instanceof Data_List_Types.Cons) {
            return new Data_Maybe.Just(new Data_Tuple.Tuple(v.back.value0, {
                current: new Data_Maybe.Just(v.back.value0),
                back: v.back.value1,
                forward: new Data_List_Types.Cons(cur, v.forward)
            }));
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Undoable.History (line 49, column 3 - line 51, column 105): " + [ v.back.constructor.name ]);
    });
};
var redo = function (v) {
    return bind(v.current)(function (cur) {
        if (v.forward instanceof Data_List_Types.Nil) {
            return Data_Maybe.Nothing.value;
        };
        if (v.forward instanceof Data_List_Types.Cons) {
            return new Data_Maybe.Just(new Data_Tuple.Tuple(v.forward.value0, {
                current: new Data_Maybe.Just(v.forward.value0),
                back: new Data_List_Types.Cons(cur, v.back),
                forward: v.forward.value1
            }));
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Undoable.History (line 61, column 3 - line 63, column 108): " + [ v.forward.constructor.name ]);
    });
};
var empty = /* #__PURE__ */ (function () {
    return {
        current: Data_Maybe.Nothing.value,
        back: mempty,
        forward: mempty
    };
})();
var change = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (v) {
        return function (v1) {
            if (v1.current instanceof Data_Maybe.Nothing) {
                return {
                    current: new Data_Maybe.Just(v),
                    back: v1.back,
                    forward: v1.forward
                };
            };
            if (v1.current instanceof Data_Maybe.Just) {
                if (eq(v)(v1.current.value0)) {
                    return v1;
                };
                if (Data_Boolean.otherwise) {
                    return {
                        current: new Data_Maybe.Just(v),
                        back: new Data_List_Types.Cons(v1.current.value0, v1.back),
                        forward: mempty
                    };
                };
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Undoable.History (line 35, column 1 - line 35, column 56): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var canUndo = function (v) {
    return Data_Maybe.isJust(v.current) && !$$null(v.back);
};
var canRedo = function (v) {
    return Data_Maybe.isJust(v.current) && !$$null(v.forward);
};
export {
    History,
    empty,
    withCurrent,
    change,
    canUndo,
    undo,
    canRedo,
    redo,
    eqHistory,
    showHistory
};
